import React from "react";

export default function LicenseTerms() {
    return (
        <div style={{ padding: "2rem", maxWidth: 800, margin: "0 auto" }}>
            <h1>Terms of Use</h1>
            <p>Last updated: {new Date().getFullYear()}</p>

            <p>
                These Terms of Use (“Terms”) govern your access and use of MuultiSpace.
                By using the platform, you agree to these Terms.
            </p>

            <h2>1. Use of the Platform</h2>
            <ul>
                <li>
                    You may create pages, upload media, and customize your content for
                    personal or commercial purposes.
                </li>
                <li>
                    You are responsible for any content you upload or publish on your
                    MuultiSpace page.
                </li>
            </ul>

            <h2>2. User Content</h2>
            <p>
                You retain ownership of the content you upload. By using the platform,
                you grant MuultiSpace a non-exclusive license to store, display, and
                serve that content as part of the service.
            </p>

            <h2>3. Prohibited Uses</h2>
            <p>You agree not to upload or distribute content that:</p>
            <ul>
                <li>Violates intellectual property rights</li>
                <li>Contains hate speech or harassment</li>
                <li>Includes explicit or illegal material</li>
                <li>Attempts to exploit or harm minors</li>
            </ul>

            <h2>4. Blockchain-Based Access</h2>
            <p>
                Some features of MuultiSpace involve token-gated access using blockchain
                ownership. You acknowledge that:
            </p>
            <ul>
                <li>Wallet interactions are irreversible</li>
                <li>Transactions are public on the blockchain</li>
                <li>
                    MuultiSpace cannot reverse or modify on-chain activity or lost access
                    due to wallet loss
                </li>
            </ul>

            <h2>5. Termination</h2>
            <p>
                We reserve the right to suspend or remove content or accounts that
                violate these Terms.
            </p>

            <h2>6. Disclaimer</h2>
            <p>
                The platform is provided “as is” without warranty of any kind. We are
                not responsible for blockchain network outages, wallet issues, or loss
                of access due to user error.
            </p>
        </div>
    );
}
